<template>
  <el-row class="reset-password">
    <el-col :span="24">
      <el-card class="login" shadow="always">
        <div slot="header" class="login__header">
          <!--          <img id="logo" src="@/assets/images/logo_blue.svg" />-->
          RESET PASSWORD
        </div
        >
        <div class="recover-instructions">
          <p>
            Choose a password that you have not already used with this account.
          </p>
        </div>
        <div>
          <el-form ref="form" :model="form">
            <div style="position: relative">
              <el-form-item>
                <el-input
                  placeholder="Password"
                  v-model.trim="form.password"
                  required
                  type="password"
                  name="password"
                  show-password
                  @blur="showPasswordRules = false"
                  @focus="showPasswordRules = true"
                  />
              </el-form-item>
              <PasswordChecker v-if="showPasswordRules" :password="form.password" />
            </div>
            <p v-if="resetPasswordErrors && resetPasswordErrors.password" class="error-msg">
              {{ resetPasswordErrors.password[0] }}
            </p>
            <el-form-item :class="{'confirm-pass-error': isConfirmPasswordInvalid}">
              <el-input
                placeholder="Type password again"
                v-model="form.password_check"
                required
                type="password"
                name="password_check"
                show-password
                @input="checkConfirmPassword"
              />
            </el-form-item>
            <p v-if="isConfirmPasswordInvalid || (resetPasswordErrors && resetPasswordErrors.confirm_password)"
               class="error-msg"> Passwords do not match </p>
          </el-form>
          <div class="login__footer">
            <router-link to="/auth/login">
              Back to login page
            </router-link>
            <el-button
              type="primary"
              class="btn-main"
              :loading="loading"
              :disabled="form.password !== form.password_check"
              @click="newPassword(form)"
            >
              Reset
            </el-button>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import PasswordChecker from "@/modules/auth/components/PasswordChecker";
import { mapActions, mapState } from 'vuex'

export default {
  mixins: [],

  components: {
    PasswordChecker
  },

  props: {},
  data() {
    return {
      form: {
        password: '',
        password_check: '',
        token: this.$route.params.token
      },
      showPasswordRules: false,
      isConfirmPasswordInvalid: false
    }
  },

  computed: {
    ...mapState('auth', ['loading', 'resetPasswordErrors'])
  },
  methods: {
    ...mapActions('auth', ['newPassword']),

    checkConfirmPassword(value) {
      this.isConfirmPasswordInvalid = false

      if (value.length > 0) {
        let password = this.form.password.split('')
        let confirmPassword = value.split('')

        confirmPassword.forEach((char, index) => {
          if (password[index] !== char) this.isConfirmPasswordInvalid = true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.reset-password {
.login {
  margin: 17vh auto;
  width: auto;
  max-width: 25rem;
  max-height: 34rem;
  text-align: center;

  .login__header {
    font-size: 2rem;
  }

  .recover-instructions {
    text-align: left;

    ul li {
      font-weight: bold;
      font-size: 15px;
    }
  }

  #logo {
    width: 180px;
    padding-right: 1rem;
    vertical-align: middle;
  }

  &__header {
    padding: 15px 20px;
  }

  &__footer {
    margin: 40px 0 15px;
    display: flex;
    justify-content: space-between;

    a {
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 800px) and (orientation: landscape) {
  .login {
    margin: 5vh auto;
  }
}

.confirm-pass-error {
  .el-input__inner {
    border-color: #E8004C;
  }

  .el-input__icon {
    color: #E8004C
  }
}
}
</style>
